export const GET_REPORT_REASON = "GET_REPORT_REASON";

export const CREATE_REPORT_REASON = "CREATE_REPORT_REASON";

export const DELETE_REPORT_REASON = "DELETE_REPORT_REASON";

export const UPDATE_REPORT_REASON = "UPDATE_REPORT_REASON";